// Sports Dashboard – industry === 7
// Functionally identical to NewDashboard1 (same APIs, same calendar view)
// Kept as a separate file so it can be customised independently later.
export { default } from "./NewDashboard1";
